// Quick Check "Your subjects": restore the full ordered list and derive the save button state.
const RANK_LABELS = new Set(["leading match", "close match", "also worth exploring"]);

export function subjectList(raw) {
  const arr = Array.isArray(raw) ? raw : typeof raw === "string" && raw.trim() ? [raw] : [];
  const out = [];
  const seen = new Set();
  for (const s of arr) {
    const v = String(typeof s === "string" ? s : s?.label || s?.name || s?.slug || "").trim();
    const k = v.toLowerCase();
    if (!v || RANK_LABELS.has(k) || seen.has(k)) continue;
    seen.add(k);
    out.push(v);
  }
  return out;
}

const ts = (v) => (v ? Date.parse(v) || 0 : 0);

// True when the Pick confirmation (e.g. Fast Fit "Use these everywhere") is newer than any explicit
// Quick Check subject edit or confirmed Course choices — the latest explicit decision wins.
export function pickIsNewest(journeyProfile) {
  const pickAt = ts(journeyProfile?.what?.subjects_confirmed_at);
  if (!pickAt || !subjectList(journeyProfile?.what?.subjects_confirmed).length) return false;
  return pickAt > Math.max(ts(journeyProfile?.how?.grades?.intended_degrees_at), ts(journeyProfile?.prove?.chances_confirmed_at));
}

// Return visit: newest Pick confirmation > this browser's last Quick Check list > signed-in profile > confirmed Course choices > Pick.
export function restoreQuickCheckSubjects({ journeyProfile, profileSubjects }) {
  if (pickIsNewest(journeyProfile)) return subjectList(journeyProfile.what.subjects_confirmed);
  const sources = [
    journeyProfile?.how?.grades?.intended_degrees,
    profileSubjects,
    journeyProfile?.prove?.chances_confirmed,
    journeyProfile?.what?.subjects_confirmed,
  ];
  for (const src of sources) {
    const list = subjectList(src);
    if (list.length) return list;
  }
  return [];
}

export function subjectChoicesState({ subjects, journeyProfile }) {
  const saved = subjectList(journeyProfile?.prove?.chances_confirmed);
  const confirmed = saved.length > 0 && (journeyProfile?.behaviour?.pillars_completed || []).includes("prove");
  const same = confirmed && saved.length === subjects.length && saved.every((s, i) => s === subjects[i]);
  const label = !confirmed ? "Confirm subject choices" : same ? "Subject choices saved" : "Update subject choices";
  return { confirmed, same, saved, label };
}

export const subjectCountText = (n, cap) => `${n} subject${n === 1 ? "" : "s"} selected · up to ${cap}`;
